import { AmountSuperScript } from "components/design/AmountSuperScript";
import { InfoItem } from "components/DesignSystem/InfoItem/InfoItem";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { formatDate } from "utils/formatDate";
import { formatNumber } from "utils/formatNumber";

export const ExchangeRateInfoRow = ({
  rate,
  currency,
  date,
  isCustom = false,
  usdEquivalent,
}: {
  rate?: number | null;
  currency: string;
  date?: string | null;
  isCustom?: boolean;
  usdEquivalent?: number | null;
}) => {
  const hasUsdEquivalent =
    typeof usdEquivalent === "number" && !Number.isNaN(usdEquivalent);

  return (
    <div className="t-col-span-2 t-grid t-grid-cols-2 t-gap-y-6 t-gap-x-20">
      <InfoItem label="Exchange Rate">
        <div className="t-flex t-flex-col t-gap-0.5">
          <div className="t-flex t-items-center t-gap-2">
            <span>
              1.00 USD = {rate ? formatNumber(Number(rate)) : "-"} {currency}
            </span>
            {isCustom && (
              <Tag tagType="white" icon={false} size="small" rounded bordered>
                Custom
              </Tag>
            )}
          </div>
        </div>
      </InfoItem>
      <InfoItem label="USD Equivalent">
        {hasUsdEquivalent ? (
          <AmountSuperScript amount={usdEquivalent as number} />
        ) : (
          "-"
        )}
      </InfoItem>
    </div>
  );
};
